import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaStar } from "react-icons/fa";

function Success() {
  return (
    <>
      <Helmet>
        <title>Order Successful - Tanarela</title>
        <meta
          name="description"
          content="Your order has been successfully placed. Thank you for choosing Tanarela."
        />
        <link rel="canonical" href="https://tanarela.com/success" />
      </Helmet>

      <section className="success-section">
        <div className="success-container">
          <FaStar className="success-icon" />
          <h1>Order Successfully Placed!</h1>
          <p>
            Thank you for your purchase from Tanarela. Your order has been
            received and is being processed. We will send you a confirmation
            email shortly with details about your delivery.
          </p>
          <p>
            Our team is preparing your premium landscape materials with care.
            You can expect to receive your order within the timeframe discussed
            during checkout.
          </p>
          <p>
            If you have any questions about your order, please do not hesitate
            to contact our customer service team at +61485588246 or{" "}
            <a href="mailto:tanarela@hotmail.com">tanarela@hotmail.com</a>
          </p>

          <div className="success-actions">
            <Link to="/">Continue Shopping</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Success;
